import React, { useState } from "react";
import DateHistoryRow from "./DateHistoryRow";

export default function HistoryByDateView({ data }) {
  const info = data.document_info;
  const dates = data.dates || [];
  const [expanded, setExpanded] = useState(new Set());

  const toggleAll = (open) =>
    open
      ? setExpanded(new Set(dates.map(d => d.date)))
      : setExpanded(new Set());

  const toggleOne = (date) => {
    setExpanded(prev => {
      const n = new Set(prev);
      n.has(date) ? n.delete(date) : n.add(date);
      return n;
    });
  };

  return (
    <>
      <div className="p-3 bg-[#5a6db3] text-white font-semibold">
        Payroll Statement Details
      </div>

      <div className="grid grid-cols-2 gap-6 bg-white border rounded-b-lg p-4 shadow">
        <div>
          <h4 className="font-semibold mb-2">Company Information</h4>
          <p><b>Company:</b> {info.company_name}</p>
          <p><b>Currency:</b> {info.currency}</p>
          <p><b>Employees:</b> {info.total_employees}</p>
          <p><b>Frequency:</b> {info.pay_frequency}</p>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Document Information</h4>
          <p><b>Filename:</b> {info.filename}</p>
          <p><b>Uploaded:</b> {info.upload_date}</p>
          <p><b>Status:</b> {info.processing_status}</p>
          <p><b>Method:</b> {info.extraction_method}</p>
        </div>
      </div>

      <div className="bg-white border shadow mt-6">
        {/* HEADER + ACTIONS */}
        <div className="flex justify-between items-center px-4 py-3 bg-[#5a6db3] text-white">
          <span className="font-semibold">
            History Report - By Date ({dates.length})
          </span>

          <div className="flex gap-2">
            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(true)}
            >
              ▼ Expand All
            </button>

            <button
              className="btn btn-sm btn-light"
              onClick={() => toggleAll(false)}
            >
              ▶ Collapse All
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm border-collapse">
            <thead className="bg-gray-100 sticky top-0 z-20">
              <tr>
                <Th w={140}>Process Date</Th>
                <Th w={120} align="center">Employees</Th>
                <Th w={160} align="right">Gross</Th>
                <Th w={160} align="right">Taxable gross</Th>
                <Th w={140} align="right">Tax</Th>
                <Th w={160} align="right">Employee NICs</Th>
                <Th w={160} align="right">Employer NICs</Th>
                <Th w={160} align="right">Net Pay</Th>
                <Th w={90} align="center">View</Th>
              </tr>
            </thead>

            <tbody>
              {dates.map(d => (
                <DateHistoryRow
                  key={d.date}
                  dateRow={d}
                  isOpen={expanded.has(d.date)}
                  onToggle={() => toggleOne(d.date)}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

/* =================== TABLE HEADER =================== */

const Th = ({ children, w, align = "left" }) => (
  <th
    style={{ minWidth: w }}
    className={`px-2 py-2 border text-${align} whitespace-nowrap`}
  >
    {children}
  </th>
);
